module.exports = __webpack_public_path__ + "img/2.a5e8fa58.png";